<template>
    <TablePlaceholder :data="efficiency">
        <template #default="{ items }">
            <b-table
                :data="items"
                :loading="isLoading"
                class="common-table"
                backend-sorting
                @sort="updateAndGetEfficiencySortings">
                <template
                    slot="header"
                    slot-scope="{ column }">
                    <div class="th-wrap">
                        {{ column.label }}
                    </div>
                </template>

                <b-table-column
                    v-slot="{ row }"
                    :label="$t(`admin.efficiency.total.table.labels.id`)">
                    {{ row.admin.intId }}
                </b-table-column>

                <b-table-column
                    v-slot="{ row }"
                    :label="$t(`admin.efficiency.total.table.labels.login`)">
                    <span class="nowrap">
                        <AdminOutput
                            :admin="{ intId: row.admin.intId, login: row.admin.login, id: row.admin.id }"
                            class="mr-1">
                        </AdminOutput>

                        <PortraitIcon :user-id="row.admin.id"></PortraitIcon>

                        <LTooltip
                            v-if="row.admin.activity.isBlocked"
                            :label="$t(`admin.users.administrators.filters.values.blocked`)"
                            position="is-bottom"
                            type="is-dark">
                            <b-icon
                                class="has-text-light"
                                icon="ban"
                                size="is-small">
                            </b-icon>
                        </LTooltip>

                        <LTooltip
                            v-if="!row.admin.activity.isConfirmed"
                            :label="$t(`admin.users.administrators.filters.values.emailUnConfirmedIcon`)"
                            position="is-bottom"
                            type="is-dark">
                            <b-icon
                                class="has-text-light line-through"
                                icon="envelope"
                                size="is-small">
                            </b-icon>
                        </LTooltip>

                        <template v-if="row.admin.name">
                            <br>
                            <small>{{ row.admin.name }}</small>
                        </template>
                    </span>
                </b-table-column>

                <!--                <b-table-column-->
                <!--                    v-slot="{ row }"-->
                <!--                    field="countWebmasters"-->
                <!--                    :label="$t(`admin.efficiency.total.table.labels.webmastersAmount`)">-->
                <!--                    {{ row.admin.activeWebmastersAmount }} /-->
                <!--                    <LTooltip :label="$t(`admin.efficiency.total.table.tooltips.partnerNetworks`)">-->
                <!--                        <span>-->
                <!--                            {{ row.admin.partnerNetworksAmount }}-->
                <!--                        </span>-->
                <!--                    </LTooltip>-->
                <!--                </b-table-column>-->

                <b-table-column
                    v-slot="{ row }"
                    sortable
                    field="COUNT_LEADS_VALID_ACCEPTED"
                    :label="$t(`admin.efficiency.total.table.labels.countLeadsValidAccepted`)">
                    {{ row.countLeadsValidAccepted }}
                </b-table-column>

                <b-table-column
                    v-slot="{ row }"
                    sortable
                    field="COUNT_DIRECT_LEADS_VALID"
                    :label="$t(`admin.efficiency.total.table.labels.countDirectLeadsValid`)">
                    {{ row.countDirectLeadsValid }}
                </b-table-column>

                <b-table-column
                    v-slot="{ row }"
                    sortable
                    field="COUNT_PARTNER_NETWORK_LEADS_VALID"
                    :label="$t(`admin.efficiency.total.table.labels.countPartnerNetworkLeadsValid`)">
                    {{ row.countPartnerNetworkLeadsValid }}
                </b-table-column>

                <b-table-column
                    v-slot="{ row }"
                    :label="$t(`admin.efficiency.total.table.labels.countKpi`)"
                    sortable
                    field="COUNT_KPI"
                    style="">
                    {{ row.countKpi }}
                </b-table-column>

                <b-table-column
                    v-slot="{ row }"
                    sortable
                    field="MONEY_COMMISSION"
                    :label="$t(`admin.efficiency.total.table.labels.moneyCommission`)">
                    {{ formatCurrency(row.moneyCommission, currency) }}
                </b-table-column>

                <b-table-column
                    v-slot="{ row }"
                    sortable
                    field="MONEY_COMMISSION_KPI"
                    :label="$t(`admin.efficiency.total.table.labels.moneyCommissionKpi`)">
                    {{ formatCurrency(row.moneyCommissionKpi, currency) }}
                </b-table-column>

                <b-table-column
                    v-slot="{ row }"
                    :visible="hasCurrencyUsd"
                    sortable
                    field="MONEY_BONUS_BEHIND_LEADS"
                    :label="$t(`admin.efficiency.total.table.labels.moneyBonusBehindLeads`)">
                    {{ formatCurrency(row.moneyBonusBehindLeads, currency) }}
                </b-table-column>

                <b-table-column
                    v-slot="{ row }"
                    :visible="hasCurrencyUsd"
                    sortable
                    field="MONEY_BONUS_BEHIND_COMMISSION"
                    :label="$t(`admin.efficiency.total.table.labels.moneyBonusBehindCommission`)">
                    {{ formatCurrency(row.moneyBonusBehindCommission, currency) }}
                </b-table-column>

                <b-table-column
                    v-slot="{ row }"
                    :visible="hasCurrencyUsd"
                    sortable
                    field="MONEY_BONUS_TOTAL"
                    :label="$t(`admin.efficiency.total.table.labels.moneyBonusTotal`)">
                    {{ formatCurrency(row.moneyBonusTotal, currency) }}
                </b-table-column>

                <b-table-column
                    v-slot="{ row }"
                    sortable
                    field="COUNT_WEBMASTER"
                    :label="$t(`admin.efficiency.total.table.labels.countWebmaster`)">
                    {{ row.countWebmaster }}
                </b-table-column>

                <b-table-column
                    v-slot="{ row }"
                    sortable
                    field="COUNT_ACTIVE_WEBMASTER"
                    :label="$t(`admin.efficiency.total.table.labels.countActiveWebmaster`)">
                    <div class="flex">
                        <div class="flex is-flex-direction-column is-align-items-center">
                            {{ row.countActiveWebmaster }}
                            <LTooltip
                                :label="$t(`admin.efficiency.total.table.tooltips.countActiveWebmaster`)"
                                type="is-info">
                                <b-tag type="is-success is-light">
                                    {{ formatPercentage(row.countWebmaster, row.countActiveWebmaster) }}
                                </b-tag>
                            </LTooltip>
                        </div>
                    </div>
                </b-table-column>

                <template #footer>
                </template>
            </b-table>
        </template>
    </TablePlaceholder>
</template>

<script>
  import TablePlaceholder from "@/components/Common/Table/TablePlaceholder";
  import PortraitIcon from "@/components/Common/Tooltip/PortraitIcon.vue";
  import { GET_EFFICIENCY } from "@core/store/action-constants";
  import { mapActions, mapState, mapMutations } from "vuex";
  import { UPDATE_EFFICIENCY_SORTINGS } from "@core/store/mutation-constants";
  import { formatCurrency, formatEmptyString, toFixed } from "@core/filters";
  import AdminOutput from "@/components/Common/Output/AdminOutput.vue";

  export default {
    name: "EfficiencyTable",
    components: {
      TablePlaceholder,
      PortraitIcon,
      AdminOutput
    },

    computed: {
      ...mapState("admin/efficiency", {
        efficiency: ({ total }) => total,
        currency: ({ filters }) => filters.currency
      }),

      isLoading () {
        return this.$wait(`admin/efficiency/${ GET_EFFICIENCY }`);
      },

      hasCurrencyUsd () {
        return this.currency === "USD";
      }

    },

    methods: {
      formatCurrency,
      formatEmptyString,

      ...mapActions("admin/efficiency", [
        GET_EFFICIENCY
      ]),

      ...mapMutations("admin/efficiency", [
        UPDATE_EFFICIENCY_SORTINGS
      ]),

      formatPercentage (data, value) {
        const percent = data ? 100 * value / data : 0;
        return `${ toFixed(percent, 1) }%`;
      },

      updateAndGetEfficiencySortings (sort, order) {
        if (sort && order) {
          this.UPDATE_EFFICIENCY_SORTINGS({ sort, order });
          this.GET_EFFICIENCY();
        }
      }
    }
  };
</script>

<style scoped lang="scss">
</style>
